(function () {
  const ROOT_SELECTOR = '[data-global-mobile-utility]';
  const MOBILE_QUERY = '(max-width: 989px)';
  const REVEAL_MIN_SCROLL = 18;
  const REVEAL_SCROLL_DELTA = 6;

  function onMediaQueryChange(mql, handler) {
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler);
      return;
    }

    if (typeof mql.addListener === 'function') {
      mql.addListener(handler);
    }
  }

  function getFloatingRewardsLaunchers(root) {
    const selectors = [
      '#appstle_loyalty_points_float',
      '#appstle_widget',
      '[id*="appstle"]',
      '[class*="appstle"]',
      '[id*="reward"]',
      '[class*="reward"]',
      '[id*="loyal"]',
      '[class*="loyal"]',
    ];

    return Array.from(document.querySelectorAll(selectors.join(','))).filter((element) => {
      if (!element || element === root || root.contains(element)) return false;

      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (style.position !== 'fixed' && style.position !== 'sticky') return false;

      const rect = element.getBoundingClientRect();
      if (rect.width < 36 || rect.height < 30) return false;

      const nearBottom = rect.bottom >= window.innerHeight - 140;
      const nearEdge = rect.left <= 140 || rect.right >= window.innerWidth - 140;

      return nearBottom && nearEdge;
    });
  }

  function initGlobalMobileUtility(root) {
    if (!root || root.dataset.bound === 'true') return;

    root.dataset.bound = 'true';

    const supportTrigger = root.querySelector('[data-global-support-trigger]');
    const mobileMedia = window.matchMedia(MOBILE_QUERY);
    let lastScrollY = window.scrollY;

    const syncFloatingLaunchers = () => {
      const shouldHide = mobileMedia.matches && root.classList.contains('is-visible');
      const chatButton = document.getElementById('diggn-chat-button');

      if (chatButton) {
        chatButton.classList.toggle('global-mobile-utility-hidden', shouldHide);
      }

      getFloatingRewardsLaunchers(root).forEach((element) => {
        element.classList.toggle('global-mobile-utility-hidden', shouldHide);
      });
    };

    const setVisible = (shouldShow) => {
      root.classList.toggle('is-visible', shouldShow);
      syncFloatingLaunchers();
    };

    if (supportTrigger) {
      supportTrigger.addEventListener('click', () => {
        const chatButton = document.getElementById('diggn-chat-button');
        if (chatButton) {
          chatButton.click();
        }
      });
    }

    const onScroll = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;

      if (!mobileMedia.matches) {
        setVisible(false);
        lastScrollY = currentScrollY;
        return;
      }

      if (currentScrollY < REVEAL_MIN_SCROLL) {
        setVisible(false);
        lastScrollY = currentScrollY;
        return;
      }

      if (Math.abs(delta) < REVEAL_SCROLL_DELTA) {
        return;
      }

      setVisible(delta < 0);
      lastScrollY = currentScrollY;
    };

    const onResize = () => {
      if (!mobileMedia.matches) {
        setVisible(false);
      } else {
        syncFloatingLaunchers();
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
    onMediaQueryChange(mobileMedia, onResize);

    syncFloatingLaunchers();
  }

  document.querySelectorAll(ROOT_SELECTOR).forEach(initGlobalMobileUtility);
})();
